"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
function transformSanityQuiz(quiz) {
    var questionSet = quiz.questions.reduce(function (a, v) {
        var _a;
        return __assign(__assign({}, a), (_a = {}, _a[v.id || v.questionId] = __assign(__assign({}, v), { 
            // since correct field always returns an array
            // if there are multiple correct answers, we pass a string and render checkboxes
            // if there's only one, we pass a string and render radio buttons
            correct: !(0, isEmpty_1.default)(v.correct)
                ? v.correct.length > 1
                    ? v.correct.map(function (ch) { return ch; })
                    : v.correct[0]
                : null }), _a));
    }, {});
    return questionSet;
}
exports.default = transformSanityQuiz;
